import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const PriceTag = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="m10.9 2.1 9.9 1.41 1.41 9.9-9.19 9.2a1 1 0 0 1-1.41 0l-9.9-9.9a1 1 0 0 1 0-1.42L10.9 2.1Zm.7 2.12L3.84 12l8.48 8.48 7.78-7.77-1.06-7.43-7.42-1.06Zm2.13 6.37a2 2 0 1 1 2.83-2.83 2 2 0 0 1-2.83 2.83Z"
    />
  </svg>
));
